import { Card, ListLayout } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { ShipmentDetails } from '../types';

interface Props {
  shipment: Pick<ShipmentDetails, 'carrier_contract'>;
}

export function CarrierContract({ shipment }: Props) {
  const { t } = useTranslation();

  if (!shipment.carrier_contract) {
    return null;
  }

  return (
    <Card.Wrapper>
      <Card.Header>{t('common.carrierContract')}</Card.Header>
      <Card.Content>
        <ListLayout.Row>
          <ListLayout.Stack>
            <ListLayout.PrimaryText
              css={{
                lineHeight: '16px',
              }}
            >
              {shipment.carrier_contract?.name}
            </ListLayout.PrimaryText>
            <ListLayout.SubRow gap="lg">
              <ListLayout.SecondaryText>
                {shipment.carrier_contract?.carrier_configuration_data
                  ? JSON.parse(shipment.carrier_contract?.carrier_configuration_data).customer_number
                  : ''}
              </ListLayout.SecondaryText>
              <ListLayout.SecondaryText>{shipment.carrier_contract?.description}</ListLayout.SecondaryText>
            </ListLayout.SubRow>
          </ListLayout.Stack>
        </ListLayout.Row>
      </Card.Content>
    </Card.Wrapper>
  );
}
